import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = number;

type ResponseData = SuccessRO;

export const regenerateTranslation: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/translations/regenerate/${id}`,
    method: 'PATCH',
});
